import Model, { ID, JsonArray, MODEL_LEVEL } from 'src/models/Model'
import TicketType from 'src/models/showing/TicketType'

export default class SeatChartAreaCategory extends Model {
  static name = 'SeatChartAreaCategory'

  static paginate = true
  static deletable = true
  static duplicatable = true
  static versioned = true

  static isConfiguration = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Ticketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      ticketTypes: {
        type: [TicketType],
        reference: true,
        default: () => ([])
      },
      excludeTicketTypes: {
        type: Boolean,
        default: false
      },
      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      },
      receiveLibraryUpdates: {
        type: Boolean,
        excludeFromDefault: true
      },
      libraryChildSiteIds: {
        type: [ID],
        output: true,
        excludeFromDefault: true
      },
      libraryDescendantSites: {
        type: JsonArray,
        output: true,
        excludeFromDefault: true
      }
    }

    this.computed = {
      effectiveTicketTypeIds () {
        if (this.excludeTicketTypes) {
          return _.difference(this.configuration.ticketTypes?.data.map('id'), this.ticketTypeIds)
        } else {
          return this.ticketTypeIds
        }
      }
    }
  }

  seatAllowedForTicketType (ticketTypeId) {
    if (this.excludeTicketTypes) {
      return !_.includes(this.ticketTypeIds, ticketTypeId)
    } else if (!this.excludeTicketTypes) {
      return _.includes(this.ticketTypeIds, ticketTypeId)
    }
  }
}
